module.exports = "<p>\n  container works!\n</p>\n"